import moment from 'moment';
import propTypes from 'prop-types';
import { React, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getConferences, getMyConferenceBooking } from '../../actions/conference';
import { checkout, getKey } from '../../actions/payment';

const ConferencePaymentMain = ({ auth: { user, isAuthenticated}, payment, conference: {conferences, bookings}, checkout, getKey, getMyConferenceBooking, getConferences}) => {

    useEffect(() => {
        getMyConferenceBooking()
    }, [getMyConferenceBooking])

    useEffect(() => {
        getConferences()
    }, [getConferences])

    useEffect(()=>{
        getKey();
    },[getKey]);

    useEffect(()=>{
        checkout(amount); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkout]);

    const currURL = window.location.href;
    const splitURL= currURL.toString().split("/");
    let n = splitURL.length;
    const amount = splitURL[n-1];
    const bookingid = splitURL[n-2];
    const booking = bookings.find(b => b._id === bookingid);

    const checkoutHandler = async (amount) => {
        const key = payment.key;
        const order = payment.order.order;
        const bookingid = splitURL[n-2];
        //const { data: { order } } = await axios.post("http://localhost:5000/api/payments/checkout", {amount});
    
        const options = {
            key,
            order_id: order.id,
            amount: order.amount,
            currency: "INR",
            name: "GharConference",
            description: "Conference Booking Charges",
            image: "https://avatars.githubusercontent.com/u/77050199?v=4",
            callback_url: `https://gharbar-backend.onrender.com/api/payments/verifyconferencepayment/${bookingid}/${amount}`,
            //callback_url: `/studentDashboard/payments/verifyPayment/${applicationid}/${amount}`,
            notes: {
                "address": "DTU, Shahbad, Daulatpur, New Delhi"
            },
            theme: {
                "color": "#9edb02"
            }
        };
        const razor = new window.Razorpay(options);
        razor.open();
    }

  return (
    <div className='container' style={{ maxWidth: '600px'}}>
        {isAuthenticated && user && user.usertype === 'guest' && (
            <Card border='success'>
                <Card.Body>
                    <Col style={{padding: '10px'}}>
                    {conferences.map(conference => conference._id === booking.conferenceid && 
                    <>
                        <Row><img src={conference.imageurl[0]} alt = 'conference img' /></Row>
                        <Row><Col>Conference: {conference.name}</Col><Col style={{textAlign: 'right'}}>Type: Conference</Col></Row>
                    </>
                    )}
                    </Col>
                    <Col style={{padding: '10px'}}>
                        <h6>Booking Details</h6>
                        <Row><Col>Guest Name</Col><Col>{booking.name}</Col></Row>
                        <Row><Col>Mobile</Col><Col>{booking.mobile}</Col></Row>
                        <Row><Col>Duration</Col><Col>1 Day</Col></Row>
                        <Row><Col>Booking For</Col><Col>{moment(booking.dateon, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
                        <Row><Col>Coupon</Col><Col>{booking.couponcode && <>{booking.couponcode}</>} {!booking.couponcode && <>Not Applied</>}</Col></Row>
                        <Row><Col>Amount</Col><Col><b><i className='fa fa-indian-rupee'></i>&nbsp;{booking.totalamount}</b></Col></Row>
                    </Col>
                </Card.Body>
                <Card.Footer>
                    <center>
                        <div className='btn btn-success' onClick={() => checkoutHandler(amount)}>
                            Confirm & Pay
                        </div>
                    </center>
                </Card.Footer>
            </Card>
        )}
    </div>
  )
}

ConferencePaymentMain.propTypes = {
    auth: propTypes.object.isRequired,
    payment: propTypes.object.isRequired,
    getKey: propTypes.func.isRequired,
    checkout: propTypes.func.isRequired,
    getMyConferenceBooking: propTypes.func.isRequired,
    getConferences: propTypes.func.isRequired,
    conference: propTypes.object.isRequired
  };
  

const mapStateToProps = (state) => ({
    auth: state.auth,
    payment: state.payment,
    conference: state.conference
});

export default connect(mapStateToProps, {getKey, checkout, getMyConferenceBooking, getConferences})(ConferencePaymentMain);